const getIsItemEnabled = (itemKey, itemKeys, currentVehicle) => {
    const isFirst = itemKeys[0] === itemKey;
    const isSecond = itemKeys[1] === itemKey;
    const isModelSelected = !!(currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.modelKey);
    const isTrimSelected = !!(currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.trimKey);
    if (isFirst)
        return true;
    if (isSecond && isModelSelected)
        return true;
    if (!isSecond && isTrimSelected)
        return true;
    return false;
};
export default getIsItemEnabled;
